import React, { useEffect, useState } from 'react'
import Astrologer_after_Login_Header from '../astrologer_after_login_header/Astrologer_after_Login_Header'
import Loader from '../../../../loader/Loader'
import { Get_Wallet_Details, get_wallet_history } from '../../../../api/category_product/Category_Product'
import { User_Authentication } from '../../../../user_authentication/User_Authentication'
import { toast } from "react-toastify";
import Astrologer_Footer from "../astrologer_footer/Astrologer_Footer"
import { get_astro_wallet_detail, get_astro_wallet_history, Withdrawal_Request } from '../../../../api/astrologer/Astrologer'
import { formatInTimeZone } from "date-fns-tz";
import { Link, useNavigate } from 'react-router-dom'

const Astrologer_Wallet = () => {
    const navigate = useNavigate()
    const [is_loading, set_Is_Loading] = useState(false)
    const [get_wallet_details, set_Wallet_Details] = useState({})
    const [get_wallet_list, set_Wallet_List] = useState([])

    const [currentPage, setCurrentPage] = useState(1);
    const [is_withdrawal, set_Is_Withdrawal] = useState(false)
    const [withdrawal_type, set_Is_Withdrawal_Type] = useState("")
    const [partial_amount, set_Partial_Amount] = useState("")
    const [error, setError] = useState({});
    const [confirmation_popup, set_Confirmation_Popup] = useState(false)
    const productsPerPage = 10;

    // Calculate total pages safely
    const totalPages = Math.ceil(get_wallet_list?.length / productsPerPage) || 1;

    // Calculate the products to display on the current page
    const startIndex = (currentPage - 1) * productsPerPage;
    const currentProduct = get_wallet_list?.slice(startIndex, startIndex + productsPerPage) || [];

    // Pagination controls
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrev = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handle_cancel_withdrawal = () => {
        set_Confirmation_Popup(true)
    }

    const handle_Keep_withdrawal = () => {
        set_Confirmation_Popup(false)
    }

    const handle_Cancel_withdrawal_request = async () => {
        setError({})
        set_Confirmation_Popup(false)
        set_Is_Withdrawal(false)
        set_Is_Withdrawal_Type("")
        set_Partial_Amount("")
    }

    const handle_Get_Wallet_Details = async () => {
        set_Is_Loading(true)
        try {
            const token = User_Authentication();
            if (!token) {
                toast("User token not found")
                set_Is_Loading(false)
                throw new Error("User token not found");
            }
            const response = await get_astro_wallet_detail({ Authorization: `Bearer ${token}` })
            if (response?.data?.status == "200") {
                set_Wallet_Details(response?.data?.data)
                set_Is_Loading(false)
            }
            else if (response?.response?.data?.status == "500") {
                set_Is_Loading(false)
            }
        }
        catch (error) {
            set_Is_Loading(false)
        }
    }
    useEffect(() => {
        handle_Get_Wallet_Details();
    }, [])

    useEffect(() => {
        const handle_get_wallet_history = async () => {
            set_Is_Loading(true)
            try {
                const token = User_Authentication();
                if (!token) {
                    toast("User token not found")
                    set_Is_Loading(false)
                    throw new Error("User token not found");
                }
                const response = await get_astro_wallet_history({ Authorization: `Bearer ${token}` })
                if (response?.data?.status == "200") {
                    set_Wallet_List(response?.data?.data)
                    set_Is_Loading(false)
                }
                else if (response?.response?.data?.status == "500") {
                    set_Is_Loading(false)
                }
            }
            catch (error) {
                set_Is_Loading(false)
            }
        }
        handle_get_wallet_history();
    }, [])

    // const formatDateTime = (isoString) => {
    //     const date = new Date(isoString);
    //     const dateOptions = {
    //         year: 'numeric',
    //         month: 'short',
    //         day: '2-digit'
    //     };
    //     const timeOptions = {
    //         hour: '2-digit',
    //         minute: '2-digit',
    //         hour12: true
    //     };
    //     const formattedDate = new Intl.DateTimeFormat('en-US', dateOptions).format(date);
    //     const formattedTime = new Intl.DateTimeFormat('en-US', timeOptions).format(date);
    //     return `${formattedDate} | ${formattedTime}`;
    // };
    const formatDate = (dateString) => {

        // const date = new Date(dateString); // Convert ISO string to Date object
        //              const formattedDate = date
        //   .toLocaleString("en-US", {
        //     month: "short",
        //     day: "2-digit",
        //     year: "numeric",
        //     hour: "2-digit",
        //     minute: "2-digit",
        //     hour12: true
        //   })
        //   .replace(",", "");
        return formatInTimeZone(dateString, "UTC", "MMM dd, yyyy | hh:mm a");
    };

    const handle_withdrawal_popup = () => {
        if (get_wallet_details?.total_amount == 0) {
            toast.error("Insufficient balance. Your wallet balance is ₹0")
            return;
        }
        set_Is_Withdrawal(true)
    }

    const handlePartialAmountChange = (e) => {
        setError({})
        const value = (e.target.value);
        if (value >= 1 || e.target.value === "") {
            if (value > get_wallet_details?.total_amount) {
                setError((prev) => ({
                    ...prev,
                    partial_amount: `Insufficient balance. Your wallet balance is ₹${get_wallet_details?.total_amount}`
                }));
                return;
            }
            else if (value < 100 && value !== "") {
                setError((prev) => ({
                    ...prev,
                    partial_amount: "Minimum withdrawal amount is ₹100"
                }));
            }

            set_Partial_Amount(value);
        }
    }

    const handle_withdrawal_request = async () => {
        setError({})
        if (!withdrawal_type) {
            setError((prev) => ({
                ...prev,
                message: "Please select the withdrawal type"
            }));
            return;
        }
        if (withdrawal_type == "partial") {
            if (!partial_amount) {
                setError((prev) => ({
                    ...prev,
                    message: "Please enter a valid Partial Withdrawal Amount"
                }));
                return;
            }
        }

        if (get_wallet_details?.total_amount == 0) {
            setError((prev) => ({
                ...prev,
                message: "Insufficient balance. Your wallet balance is ₹0"
            }));
            return;
        }

        const withdrawal_amount =
            withdrawal_type === "full"
                ? get_wallet_details?.total_amount
                : partial_amount;

        if (withdrawal_amount < 100) {
            setError((prev) => ({
                ...prev,
                message: "Minimum withdrawal amount is ₹100"
            }));
            return;
        }

        if (withdrawal_amount > get_wallet_details?.total_amount) {
            setError((prev) => ({
                ...prev,
                message: `Insufficient balance. Your wallet balance is ₹${get_wallet_details?.total_amount}`
            }));
            return;
        }

        if (!get_wallet_details?.bank_detail) {
            toast.error("🏦 Please add your Bank Details before making a withdrawal")
            navigate("/astrologer-bank-details")
            return;
        }

        const data = {
            wallet_id: get_wallet_details?.id,
            amount: withdrawal_amount
        }
        try {
            const token = User_Authentication();
            if (!token) {
                toast("User token not found")
                set_Is_Loading(false)
                throw new Error("User token not found");
            }
            set_Is_Loading(true)
            const response = await Withdrawal_Request(data, { Authorization: `Bearer ${token}` })
            if (response?.status == 200) {
                toast(response?.data?.message)
                set_Is_Withdrawal(false)
                handle_Get_Wallet_Details();
                handle_Cancel_withdrawal_request();
            }
            if (response?.response?.datastatus == 500) {
                toast.error(response?.response?.data?.message)
            }
        } catch (error) {
            console.error(error)
        } finally {
            set_Is_Loading(false)
        }
    }
    return (
        <div>
            {/*  */}
            <Astrologer_after_Login_Header />
            {/* <-------- ToastContainer ------------> */}
            {
                is_loading ? (
                    <Loader />
                ) : (

                    <div className="bg-[#f8f8f8] py-8">
                        <div
                            className=" mx-auto min-[1300px]:max-w-[1240px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                            <div className="myaccount-section w-full">
                                <div className="container-x mx-auto">
                                    <div className="w-full my-10">
                                        <div className="w-full bg-white shadow-xl p-5">
                                            <div className="my_account w-full flex space-x-10">
                                                {/* <User_Dashbaord_Common_Section /> */}
                                                <div className="flex-1">

                                                    <div className="item-body w-full">
                                                        <div className="welcome-msg w-full">
                                                            <div className='flex justify-between'>
                                                                <h1 className="font-bold text-[24px] text-qblack">Wallet
                                                                </h1>
                                                                <div className='flex gap-3'>
                                                                    <button type='button' className='text-[12px] bg-red-600 px-2 py-1 text-white rounded-sm hover:bg-red-700' onClick={handle_withdrawal_popup}
                                                                    >Withdrawal</button>

                                                                    <button type='button' className='text-[12px] bg-green-700 px-2 py-1 text-white rounded-sm hover:bg-green-800' onClick={() => navigate("/withdrawal-history")}>Withdrawal History</button>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 items-center mt-3 border-b pb-5">
                                                            <div
                                                                className="w-full h-[120px] transition-all flex gap-5 duration-300 ease-in-out bg-blue-700 rounded-[10px] p-[15px]">
                                                                <div
                                                                    className="w-[62px] h-[62px] rounded bg-gray-100 flex justify-center items-center">
                                                                    <span><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" className="bi bi-wallet-fill" viewBox="0 0 16 16">
                                                                        <path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v2h6a.5.5 0 0 1 .5.5c0 .253.08.644.306.958.207.288.557.542 1.194.542s.987-.254 1.194-.542C9.42 6.644 9.5 6.253 9.5 6a.5.5 0 0 1 .5-.5h6v-2A1.5 1.5 0 0 0 14.5 2z" />
                                                                        <path d="M16 6.5h-5.551a2.7 2.7 0 0 1-.443 1.042C9.613 8.088 8.963 8.5 8 8.5s-1.613-.412-2.006-.958A2.7 2.7 0 0 1 5.551 6.5H0v6A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5z" />
                                                                    </svg></span>
                                                                </div>
                                                                <div>
                                                                    <p className="text-md text-white font-medium">Available Balance
                                                                    </p>
                                                                    <span className="text-2xl font-bold text-white mt-1 block">Rs.{get_wallet_details?.total_amount}</span>
                                                                </div>
                                                            </div>
                                                            <div
                                                                className="w-full h-[120px] transition-all flex gap-5 duration-300 ease-in-out bg-yellow-400 rounded-[10px] p-[15px]">
                                                                <div
                                                                    className="w-[62px] h-[62px] rounded bg-gray-100 flex justify-center items-center">
                                                                    <span><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" className="bi bi-wallet-fill" viewBox="0 0 16 16">
                                                                        <path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v2h6a.5.5 0 0 1 .5.5c0 .253.08.644.306.958.207.288.557.542 1.194.542s.987-.254 1.194-.542C9.42 6.644 9.5 6.253 9.5 6a.5.5 0 0 1 .5-.5h6v-2A1.5 1.5 0 0 0 14.5 2z" />
                                                                        <path d="M16 6.5h-5.551a2.7 2.7 0 0 1-.443 1.042C9.613 8.088 8.963 8.5 8 8.5s-1.613-.412-2.006-.958A2.7 2.7 0 0 1 5.551 6.5H0v6A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5z" />
                                                                    </svg></span>
                                                                </div>
                                                                <div>
                                                                    <p className="text-md text-black font-medium">Weakly Earning
                                                                    </p>
                                                                    <span className="text-2xl font-bold text-black mt-1 block">Rs.{get_wallet_details?.weakly_earn}</span>
                                                                </div>
                                                            </div>
                                                            <div
                                                                className="w-full h-[120px] transition-all flex gap-5 duration-300 ease-in-out bg-green-600 rounded-[10px] p-[15px]">
                                                                <div
                                                                    className="w-[62px] h-[62px] rounded bg-gray-100 flex justify-center items-center">
                                                                    <span><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" className="bi bi-wallet-fill" viewBox="0 0 16 16">
                                                                        <path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v2h6a.5.5 0 0 1 .5.5c0 .253.08.644.306.958.207.288.557.542 1.194.542s.987-.254 1.194-.542C9.42 6.644 9.5 6.253 9.5 6a.5.5 0 0 1 .5-.5h6v-2A1.5 1.5 0 0 0 14.5 2z" />
                                                                        <path d="M16 6.5h-5.551a2.7 2.7 0 0 1-.443 1.042C9.613 8.088 8.963 8.5 8 8.5s-1.613-.412-2.006-.958A2.7 2.7 0 0 1 5.551 6.5H0v6A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5z" />
                                                                    </svg></span>
                                                                </div>
                                                                <div>
                                                                    <p className="text-md text-white font-medium">Monthly Earning
                                                                    </p>
                                                                    <span className="text-2xl font-bold text-white mt-1 block">Rs.{get_wallet_details?.monthly_earn}</span>
                                                                </div>
                                                            </div>
                                                            {/* <div
                                                                className="w-full h-[120px] transition-all flex gap-5 duration-300 ease-in-out bg-orange-600 rounded-[10px] p-[15px]">
                                                                <div
                                                                    className="w-[62px] h-[62px] rounded bg-gray-100 flex justify-center items-center">
                                                                    <span><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" className="bi bi-wallet-fill" viewBox="0 0 16 16">
                                                                        <path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v2h6a.5.5 0 0 1 .5.5c0 .253.08.644.306.958.207.288.557.542 1.194.542s.987-.254 1.194-.542C9.42 6.644 9.5 6.253 9.5 6a.5.5 0 0 1 .5-.5h6v-2A1.5 1.5 0 0 0 14.5 2z" />
                                                                        <path d="M16 6.5h-5.551a2.7 2.7 0 0 1-.443 1.042C9.613 8.088 8.963 8.5 8 8.5s-1.613-.412-2.006-.958A2.7 2.7 0 0 1 5.551 6.5H0v6A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5z" />
                                                                    </svg></span>
                                                                </div>
                                                                <div>
                                                                    <p className="text-md text-white font-medium">Monthly Earning
                                                                    </p>
                                                                    <span className="text-2xl font-bold text-white mt-1 block">Rs.{get_wallet_details?.monthly_earn}</span>
                                                                </div>
                                                            </div>
                                                            <div
                                                                className="w-full h-[120px] transition-all flex gap-5 duration-300 ease-in-out bg-red-500 rounded-[10px] p-[15px]">
                                                                <div
                                                                    className="w-[62px] h-[62px] rounded bg-gray-100 flex justify-center items-center">
                                                                    <span><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" className="bi bi-wallet-fill" viewBox="0 0 16 16">
                                                                        <path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v2h6a.5.5 0 0 1 .5.5c0 .253.08.644.306.958.207.288.557.542 1.194.542s.987-.254 1.194-.542C9.42 6.644 9.5 6.253 9.5 6a.5.5 0 0 1 .5-.5h6v-2A1.5 1.5 0 0 0 14.5 2z" />
                                                                        <path d="M16 6.5h-5.551a2.7 2.7 0 0 1-.443 1.042C9.613 8.088 8.963 8.5 8 8.5s-1.613-.412-2.006-.958A2.7 2.7 0 0 1 5.551 6.5H0v6A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5z" />
                                                                    </svg></span>
                                                                </div>
                                                                <div>
                                                                    <p className="text-md text-white font-medium">Monthly Earning
                                                                    </p>
                                                                    <span className="text-2xl font-bold text-white mt-1 block">Rs.{get_wallet_details?.monthly_earn}</span>
                                                                </div>
                                                            </div> */}
                                                        </div>
                                                        <div className="mt-5">
                                                            <h4 className="text-lg font-medium text-gray-500 pb-2">Transactions History</h4>
                                                            <table className="table text-sm table_hover w-full">
                                                                <thead>
                                                                    <tr>
                                                                        <th>S.No</th>
                                                                        <th>Name</th>
                                                                        <th>Date</th>
                                                                        <th>Amount</th>
                                                                        <th>Pay</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {currentProduct?.length > 0 ? (
                                                                        currentProduct?.map((get_wallet_result, index) => {
                                                                            return (
                                                                                <tr>
                                                                                    <td>{startIndex + index + 1}</td>
                                                                                    <td>{get_wallet_result?.place}</td>
                                                                                    <td>{formatDate(get_wallet_result?.created_at)}</td>
                                                                                    {
                                                                                        get_wallet_result?.transaction_type == "CR" ? (
                                                                                            <td className="text-green-700 font-medium">+Rs.{get_wallet_result?.req_amount}</td>
                                                                                        ) : (
                                                                                            <td className="text-red-700 font-medium">-Rs.{get_wallet_result?.req_amount}</td>
                                                                                        )
                                                                                    }
                                                                                    <td>Wallet</td>
                                                                                </tr>
                                                                            )
                                                                        })
                                                                    ) : (
                                                                        <tr>
                                                                            <td colSpan="5" className="py-4">
                                                                                <div className="flex justify-center items-center">
                                                                                    No Transactions Found
                                                                                </div>
                                                                            </td>
                                                                        </tr>

                                                                    )

                                                                    }
                                                                </tbody>
                                                            </table>
                                                            {/* <!-- Pagination Start --> */}
                                                            <div className="gi-pro-pagination pt-[15px] pb-[15px] flex justify-between items-center border-t-[1px] border-solid border-[#eee] max-[575px]:flex-col">
                                                                <span className="text-[14px] text-[#777] max-[575px]:mb-[10px]">Showing {startIndex + 1}-{Math.min(startIndex + productsPerPage, get_wallet_list?.length)} of {get_wallet_list?.length} Astrologer Wallet(s)</span>
                                                                <ul className="gi-pro-pagination-inner flex">
                                                                    {currentPage > 1 && (
                                                                        <li>
                                                                            <button
                                                                                onClick={handlePrev}
                                                                                className="next w-auto px-[13px] text-[#fff] m-1 p-2 bg-[#5caf90] leading-[30px] h-[32px] bg-red-500 flex text-center align-top text-[16px] justify-center items-center rounded-[5px]"
                                                                            >
                                                                                Prev
                                                                            </button>
                                                                        </li>
                                                                    )}
                                                                    {[...Array(totalPages).keys()].map((page) => (
                                                                        <li key={page} className="inline-block float-left mr-[5px]">
                                                                            <button
                                                                                onClick={() => handlePageChange(page + 1)}
                                                                                className={`transition-all duration-[0.3s] m-1 p-2 ease-in-out w-[32px] h-[32px] font-light 
                    text-[#777] leading-[32px] bg-[#eee] flex text-center align-top 
                    text-[16px] justify-center items-center rounded-[5px]
                    ${currentPage === page + 1 ? 'active bg-red-500 text-white' : 'bg-gray-300 text-white'}`}
                                                                            >
                                                                                {page + 1}
                                                                            </button>
                                                                        </li>
                                                                    ))}
                                                                    {currentPage < totalPages && (
                                                                        <li>
                                                                            <button
                                                                                onClick={handleNext}
                                                                                className="next w-auto px-[13px] text-[#fff] m-1 p-2 bg-[#5caf90] leading-[30px] h-[32px] bg-red-500 flex text-center align-top text-[16px] justify-center items-center rounded-[5px]"
                                                                            >
                                                                                Next
                                                                            </button>
                                                                        </li>
                                                                    )}
                                                                </ul>

                                                            </div>

                                                            {is_withdrawal && (
                                                                <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
                                                                    <div className="bg-white p-8 rounded-lg shadow-lg w-1/2 md:w-1/3">
                                                                        {/* Modal Content */}
                                                                        <div className='flex flex-col sm:flex-row text-center items-center gap-2 mb-4'>
                                                                            <div className="text-md font-semibold">Available Balance: </div>
                                                                            <span className="text-md"> Rs.{get_wallet_details?.total_amount}</span>
                                                                        </div>
                                                                        <div className=''>
                                                                            <form className='flex flex-col gap-2'>
                                                                                <div className='flex gap-3 items-center'>
                                                                                    <input type='radio' name='withdrawal_type'
                                                                                        value="full" onChange={(e) => {
                                                                                            setError({})
                                                                                            set_Is_Withdrawal_Type(e.target.value)
                                                                                        }} checked={withdrawal_type == "full"} />
                                                                                    <label htmlFor='total-balance' className='mb-0'>Fully Withdrawal</label>
                                                                                </div>

                                                                                <div className='flex gap-3 items-center'>
                                                                                    <input type='radio' name='withdrawal_type' value="partial" onChange={(e) => {
                                                                                        setError({})
                                                                                        set_Is_Withdrawal_Type(e.target.value)
                                                                                    }} checked={withdrawal_type == "partial"} />
                                                                                    <label htmlFor='total-balance' className='mb-0'>Partial Withdrawal</label>
                                                                                </div>
                                                                                <div className={withdrawal_type == "partial" ? "block" : "hidden"}>
                                                                                    <input type='number' className="w-full px-6 bg-transparent border-[2px] border-solid border-[#eee] rounded-[5px] text-[#777] text-[14px] outline-[0] h-[40px] no-spinner" name='partial_amount' value={partial_amount} placeholder='Enter amount (₹100 or more)' onChange={handlePartialAmountChange} />
                                                                                    {error.partial_amount && (
                                                                                        <p className="text-red-500 text-sm mt-1">{error.partial_amount}</p>
                                                                                    )}

                                                                                </div>
                                                                                {error.message && (
                                                                                    <p className="text-red-500 text-sm mt-1">{error.message}</p>
                                                                                )}
                                                                            </form>
                                                                        </div>
                                                                        <div className="flex flex-col sm:flex-row justify-end gap-4 mt-4">
                                                                            <button
                                                                                onClick={handle_cancel_withdrawal}
                                                                                className="bg-gray-300 text-gray-700 py-2 px-4 rounded-lg text-sm">Close</button>
                                                                            <button type='button' onClick={() => handle_withdrawal_request()} className="bg-red-800 text-white py-2 px-4 rounded-lg text-sm">Withdrawal</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {confirmation_popup && (
                                                                <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
                                                                    <div className="bg-white p-8 rounded-lg shadow-lg w-1/2 md:w-1/3">
                                                                        {/* Modal Content */}
                                                                        <div className='flex flex-col sm:flex-row text-center items-center gap-2 mb-4'>
                                                                            <div className="text-md font-semibold">Cancel Withdrawal? </div>

                                                                        </div>
                                                                        <p className="text-sm text-gray-600 mb-4">
                                                                            Are you sure you want to cancel this withdrawal?
                                                                            The amount will remain in your wallet.
                                                                        </p>
                                                                        <div className="flex flex-col sm:flex-row justify-end gap-4 mt-4">
                                                                            <button
                                                                                onClick={handle_Keep_withdrawal}
                                                                                className="bg-gray-300 text-gray-700 py-2 px-4 rounded-lg text-sm">Keep Withdrawal</button>
                                                                            <button type='button' onClick={() => handle_Cancel_withdrawal_request()} className="bg-red-800 text-white py-2 px-4 rounded-lg text-sm">Cancel Withdrawal</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
            {/*  */}
            <Astrologer_Footer />
        </div>
    )
}

export default Astrologer_Wallet